import { formatToCNPJ } from 'brazilian-values'
import React from 'react'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayInvestmentRobots(props) {
  const { questionData } = props
  const classes = styles()

  const buildInvestmentRobot = (platformInfo) => {
    return (
      <div className={classes.answersContainer} key={platformInfo.key}>
        <p>
          <span>Razão social: </span>
          {platformInfo.corporate_name}
        </p>
        <p>
          <span>CNPJ: </span>
          {formatToCNPJ(platformInfo.cnpj)}
        </p>
        <p>
          <span>Plataformas Desenvolvidas: </span>
          {platformInfo.created_platforms}
        </p>
        <p>
          <span>Cargo: </span>
          {platformInfo.role}
        </p>
        <p>
          <span>Atividades desenvolvidas: </span>
          {platformInfo.developed_activities}
        </p>
        <p>
          <span>Continuará desempenhando atividade? </span>
          {platformInfo.will_keep_role ? 'Sim' : 'Não'}
        </p>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento das Plataformas:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não oferece ou trabalha em nenhuma empresa que fornece robôs de investimento não homologados pela XP."
        funcBuildItem={buildInvestmentRobot}
      />

    </div>
  )
}

export default DisplayInvestmentRobots
